import React from "react";
import { useHistory } from "react-router-dom";
const EbmsDashboard = () => {
  const history = useHistory();
  return (
    <div>
      <h1>EBMS DASHBOARD</h1>
      <hr></hr>

      <div
        className="card text-white bg-primary col-md-2"
        onClick={() => {
          history.push({
            pathname: "/ebms/projects",
          });
        }}
      >
        <div className="card-body">
          <p className="card-text text-center h3 text-white">PROJECTS</p>
        </div>
      </div>

      <div
        className="card text-white bg-primary col-md-2"
        onClick={() => {
          history.push({
            pathname: "/ebms/surveys",
          });
        }}
      >
        <div className="card-body">
          <p className="card-text text-center h3 text-white">SURVEYS</p>
        </div>
      </div>
    </div>
  );
};

export default EbmsDashboard;
